import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/epicpublicwebsites/epicdotcom-nextjs/app/(languageAgnostic)/(fullSize)/software/[slug]/flipCardStatefulPortion.tsx");
;
import(/* webpackMode: "eager" */ "/builds/epicpublicwebsites/epicdotcom-nextjs/node_modules/next/dist/client/image-component.js");
